import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'
import { BehaviorSubject } from 'rxjs'

const listParticipants = new BehaviorSubject(
  JSON.parse(localStorage.getItem('participants'))
)

const userProfileInfor = new BehaviorSubject(
  JSON.parse(localStorage.getItem('userInfo'))
)

const listOrg = new BehaviorSubject(
  JSON.parse(localStorage.getItem('listOrg'))
)

export const utilService = {
  getTag,
  addTag,
  getState,
  getUtilityState,
  getListPricingType,
  getListSwing,
  getListTerm,
  getListContact,
  deleteTag,
  updateTag,
  getCurrentUser,
  getNoteByUser,
  addNoteToContact,
  deleteNote,
  updateNote,
  setListOrg,
  userInfor: userProfileInfor.asObservable(),
  get userInforValue () {
    return userProfileInfor.value
  },
  currentListParticipants: listParticipants.asObservable(),
  get currentListParticipantsValue () {
    return listParticipants.value
  },
  currentListOrgs: listOrg.asObservable(),
  get currentListOrgsValue () {
    return listOrg.value
  }
}

function getCurrentUser () {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/users/me/?expand=profile`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('userInfo', JSON.stringify(response))
      userProfileInfor.next(response)
      return response
    })
}

function getListContact (request) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/nylas-contacts/?limit=9999999`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('participants', JSON.stringify(response.results))
      listParticipants.next(response.results)
      return response
    })
}

function getUtilityState () {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/utility-states/?limit=9999999&expand=state,utility`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(states => {
      return states
    })
}

function getState () {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/states/?limit=9999999`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(states => {
      return states
    })
}

function getTag () {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/tag/?limit=9999999`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(tags => {
      return tags
    })
}

function deleteTag (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/tag/${id}/`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(tags => {
      return tags
    })
}

function updateTag (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/tag/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(tags => {
      return tags
    })
}

function addTag (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/tag/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(tag => {
      return tag
    })
}

function getNoteByUser (contactId, contentType) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/notes/?object_id=${contactId}&content_type=${contentType}&limit=9999999&expand=created_by`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(rs => {
      return rs
    })
}

function addNoteToContact (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/notes/?expand=created_by`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(rs => {
      return rs
    })
}

function deleteNote (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/notes/${id}/?expand=created_by`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(rs => {
      return rs
    })
}

function updateNote (note, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/notes/${id}/?expand=created_by`
  return fetch(url, requestOptions.put(note))
    .then(handleResponse)
    .then(rs => {
      return rs
    })
}

function getListTerm () {
  return [
    { text: '1', id: '1' },
    { text: '2', id: '2' },
    { text: '3', id: '3' },
    { text: '4', id: '4' },
    { text: '5', id: '5' },
    { text: '6', id: '6' },
    { text: '7', id: '7' },
    { text: '8', id: '8' },
    { text: '9', id: '9' },
    { text: '10', id: '10' },
    { text: '11', id: '11' },
    { text: '12', id: '12' },
    { text: '13', id: '13' },
    { text: '14', id: '14' },
    { text: '15', id: '15' },
    { text: '16', id: '16' },
    { text: '17', id: '17' },
    { text: '18', id: '18' },
    { text: '19', id: '19' },
    { text: '20', id: '20' },
    { text: '21', id: '21' },
    { text: '22', id: '22' },
    { text: '23', id: '23' },
    { text: '24', id: '24' },
    { text: '25', id: '25' },
    { text: '26', id: '26' },
    { text: '27', id: '27' },
    { text: '28', id: '28' },
    { text: '29', id: '29' },
    { text: '30', id: '30' },
    { text: '31', id: '31' },
    { text: '32', id: '32' },
    { text: '33', id: '33' },
    { text: '34', id: '34' },
    { text: '35', id: '35' },
    { text: '36', id: '36' },
    { text: '37', id: '37' },
    { text: '38', id: '38' },
    { text: '39', id: '39' },
    { text: '40', id: '40' },
    { text: '41', id: '41' },
    { text: '42', id: '42' },
    { text: '43', id: '43' },
    { text: '44', id: '44' },
    { text: '45', id: '45' },
    { text: '46', id: '46' },
    { text: '47', id: '47' },
    { text: '48', id: '48' }
  ]
}
function getListSwing () {
  return [
    { text: '5%', id: '0.05' },
    { text: '10%', id: '0.1' },
    { text: '15%', id: '0.15' },
    { text: '20%', id: '0.2' },
    { text: '25%', id: '0.25' },
    { text: '30%', id: '0.3' },
    { text: '35%', id: '0.35' },
    { text: '40%', id: '0.4' },
    { text: '45%', id: '0.45' },
    { text: '50%', id: '0.5' },
    { text: '55%', id: '0.55' },
    { text: '60%', id: '0.6' },
    { text: '65%', id: '0.65' },
    { text: '70%', id: '0.7' },
    { text: '75%', id: '0.75' },
    { text: '80%', id: '0.8' },
    { text: '85%', id: '0.85' },
    { text: '90%', id: '0.9' },
    { text: '95%', id: '0.95' },
    { text: '100%', id: '1' }
  ]
}
function getListPricingType () {
  return [
    { text: 'Fixed', id: 'fixed' },
    { text: 'Nymex+', id: 'nymex+' },
    { text: 'Index', id: 'index' }
  ]
}

function setListOrg (data) {
  listOrg.next(data)
}



// WEBPACK FOOTER //
// ./src/services/util.service.js